
<script>
export default {
  name: "Login",
  data: () => ({
   
  }),
  components: {
  },
  methods: {
    push(token, user, pack, perm, mode, admin) {
      this.$session.set('token', token)
      this.$session.set('username', user)
      this.$session.set('package', pack)
      this.$session.set('controlperm', perm)
      this.$session.set('role', mode)
      // console.log(admin)
      if(admin) this.$session.set('admin', admin)
      this.$http.post(this.$url+'checkin', {
        username: this.$session.get('username')
      }).catch((err) => {
        // console.log(err)
      })
      this.activeLoading = true
      this.$vs.loading({
        type: 'default'
      }) 
      setTimeout( ()=> {
        this.activeLoading = false
        this.$vs.loading.close()
        this.$router.push({
          name: 'Overview'
        })
      }, 500)
    },
    async login() {
      await this.$http.post(this.$url+'login', {
        headers: {
          'Access-Control-Request-Method': '*',
          'Access-Control-Request-Headers': '*',
          'Origin': '*'
        },
        username: this.username,
        password: this.password,
        role: this.checkbox
      }).then((result) => {
        // // console.log(result.data[0])
        if(result.status == 200) {
          if(result.data[0].status == 'login') {
            this.$vs.notify({
              title: "Login was unsuccessful",
              text: "Please wait for session expire or This user is already login",
              color: "danger",
              position: "top-center",
              icon: 'clear'
            });
          }
          else if(result.data[0].admin) {
            console.log('you are user')
            this.$http.get(this.$url+'getAdminData/'+result.data[0].admin)
            .then((tresult) => {
              this.$http.post(this.$url+'checkin', {
                username: this.$session.get('username')
              }).catch((err) => {
                // console.log(err)
              })
              console.log(tresult.data)
              this.push(tresult.data[0].token,result.data[0].username,tresult.data[0].package,result.data[0].controlperm,'user',result.data[0].admin)
            })
          }else{
            this.push(result.data[0].token,result.data[0].username,result.data[0].package,null,'admin',result.data[0].username)
          }
        }
      }).catch((err) => {
        // console.log(err.response)
        if(err.response.status == 401) {
          this.$vs.notify({
            title: "Login was unsuccessful",
            text: "The user name or password provided is incorrect.",
            color: "danger",
            position: "top-center",
            icon: 'clear'
          });
        }else if(err.response.status == 403) {
          this.$vs.notify({
            title: "Login was unsuccessful",
            text: "Please wait for session expire or This user is already login",
            color: "danger",
            position: "top-center",
            icon: 'clear'
          });
        }else{
          this.$vs.notify({
            title: "Login was unsuccessful",
            text: "Something happen with the server",
            color: "danger",
            position: "top-center",
            icon: 'clear'
          });
        }
      })
    },
    register() {
      this.$router.push({
        name: 'Register'
      })
    }
  },
  created() {
  }
}
</script>
